export const leaseContractTypes = [
  'COMMERCIAL_LEASE',
  'BEFA',
  'ACQUISITION',
  'CONSTRUCTION_LEASE',
] as const
export type LeaseContractType = (typeof leaseContractTypes)[number]

export const leaseContractTypeLabel: Record<LeaseContractType, string> = {
  COMMERCIAL_LEASE: 'Bail Co',
  BEFA: 'Befa',
  ACQUISITION: 'Acquisition',
  CONSTRUCTION_LEASE: 'Bail à Construction',
}
